export default "__VITE_ASSET__B_bIrU34__"